var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "videoContainer",
      staticClass: "videoContainer",
      style: _vm.videoContainerStyle,
    },
    [
      _c("div", { staticClass: "vidImgWrapper" }, [
        _vm.useLazy
          ? _c("div", { staticStyle: { width: "100%" } }, [
              _vm.index > 2 &&
              Object.keys(_vm.video.snippet.thumbnails).length > 0
                ? _c("img", {
                    directives: [
                      {
                        name: "lazy",
                        rawName: "v-lazy",
                        value: _vm.video.snippet.thumbnails.medium.url,
                        expression: "video.snippet.thumbnails.medium.url",
                      },
                    ],
                    attrs: {
                      "data-id": _vm.video.id,
                      alt: _vm.video.snippet.title,
                    },
                  })
                : _vm._e(),
              _vm.index <= 2 &&
              Object.keys(_vm.video.snippet.thumbnails).length > 0
                ? _c("img", {
                    attrs: {
                      src: _vm.video.snippet.thumbnails.medium.url,
                      alt: _vm.video.snippet.title,
                    },
                  })
                : _vm._e(),
            ])
          : _c("div", { staticStyle: { width: "100%" } }, [
              _c("img", {
                attrs: {
                  src: _vm.video.snippet.thumbnails.medium.url,
                  alt: _vm.video.snippet.title,
                },
              }),
            ]),
        _c("div", { staticClass: "vidImgPlayLogo" }, [
          _c(
            "svg",
            {
              attrs: {
                id: "Layer_1",
                xmlns: "http://www.w3.org/2000/svg",
                width: "30",
                height: "30",
                viewBox: "0 0 30 30",
              },
            },
            [
              _c("defs"),
              _c("path", {
                staticClass: "cls-1",
                attrs: {
                  fill: "",
                  d: "M26.32,12.26c.96,.59,1.54,1.63,1.54,2.75s-.58,2.16-1.54,2.69L7.03,29.48c-.99,.66-2.23,.69-3.25,.12-1.01-.57-1.64-1.64-1.64-2.81V3.21c0-1.16,.63-2.23,1.64-2.8,1.01-.57,2.26-.55,3.25,.06L26.32,12.26Z",
                },
              }),
            ]
          ),
        ]),
        typeof _vm.videoDuration.minutes != "undefined"
          ? _c("span", { staticClass: "durationOfVid" }, [
              _c("i", { staticClass: "fas fa-clock" }),
              _vm._v(
                _vm._s(_vm.minTwoDigits(_vm.videoDuration.minutes)) +
                  ":" +
                  _vm._s(_vm.minTwoDigits(_vm.videoDuration.seconds))
              ),
            ])
          : _vm._e(),
      ]),
      _c("p", { staticClass: "title" }, [
        _vm._m(0),
        _c("span", { staticClass: "titleText" }, [
          _vm._v(
            _vm._s(
              _vm._f("truncate")(
                _vm.video.snippet.title.replace(" | Pharma Nord", ""),
                _vm.numberOfCharacters,
                "..."
              )
            )
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "play" }, [
      _c("i", { staticClass: "fas fa-play" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }